import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
const useStyles = createUseStyles((_) => ({
  containerHeaderLeft: {
    borderRadius: "15px",
    padding: "15px",
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  subContainerHeaderLeft: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    width: "100%",
  },

  divImages: {
    position: "relative",
    display: "flex",
    borderRadius: "10px",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "117px",
    width: "117px",
    height: "117px",
    overflow: "hidden",
    backgroundColor: colors.default,
    cursor: "pointer",
    "&:hover $divImagesOverlay": {
      opacity: 1,
    },
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  },
  divImagesOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "6px",
    borderRadius: "10px",
    backgroundColor: "rgba(15,23,42,0.55)",
    color: "#fff",
    fontSize: "11px",
    lineHeight: "14px",
    fontWeight: 600,
    opacity: 0,
    transition: "opacity 0.15s ease-in-out",
  },
  hiddenFileInput: {
    display: "none",
  },
  divCollaborator: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    padding: "10px 5px 10px 10px",
    borderRadius: "10px",
    width: "100%",
  },
  divCollaboratorText: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  divContainerInfo: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    "& > div": {
      flex: 1,
    },
  },
  subContainerInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    justifyContent: "space-between",
    minWidth: "240px",
  },

  containerText: {
    padding: "19px 15px 29px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
}));

export default useStyles;
